import { render, staticRenderFns } from "./spinner.vue?vue&type=template&id=83a174b8&scoped=true&"
import script from "./spinner.vue?vue&type=script&lang=ts&"
export * from "./spinner.vue?vue&type=script&lang=ts&"
import style0 from "./spinner.vue?vue&type=style&index=0&id=83a174b8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83a174b8",
  null
  
)

export default component.exports